// Calendar-day arithmetic on the date part only — a date-only stamp
// ("2026-10-12") must not slip a day because of the machine's timezone.
//
// Two surfaces age a row ("3d old", "1 day open"). They must agree, so the
// arithmetic lives here once and both read it.

const DAY = 86400000;

export const dayIndex = (value) => {
  const s = String(value ?? "");
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (m) {
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).getTime();
    return Number.isNaN(d) ? null : Math.floor(d / DAY);
  }
  const t = new Date(s).getTime();
  return Number.isNaN(t) ? null : Math.floor(t / DAY);
};

// Days since the stamp, on the calendar. A stamp of "now minus one day" is
// one day old whatever the clock says later the same day.
export const daysSince = (value) => {
  const d = dayIndex(value);
  if (d === null) return null;
  return Math.floor(Date.now() / DAY) - d;
};
